import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import config from "../../config";
import Tables from "../../views/admin/tables/Tables";
import DistrictMode from "../../views/district/DistrictMode";
import Dashboard from "../../views/admin/dashboard/Dashboard";
import Login from "../../views/admin/login/Login";
import Poi from "../../views/poi/Poi";
import { default as DistrictPoi } from "../../views/district/poi/Poi";

import Welcome from "../../views/welcome/Welcome";
import { NotFound } from "../../views/not-found/NotFound";
import Layout from "../../views/layout/Layout";

// import { auth } from "../../store";

function PrivateRoute({ component: Component, ...rest }) {
	return (
		<Route
			{...rest}
			render={props =>
				localStorage.getItem("auth_token") ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: "/login",
							state: { from: props.location }
						}}
					/>
				)
			}
		/>
	);
}

function PublicRoute({ component: Component, ...rest }) {
	return (
		<Route
			{...rest}
			render={props =>
				localStorage.getItem("auth_token") ? (
					<Redirect
						to={{
							pathname: "/admin"
						}}
					/>
				) : (
					<Component {...props} />
				)
			}
		/>
	);
}

const { buildings } = config;

function Routes() {
	return (
		<TransitionGroup>
			<CSSTransition classNames="fade" timeout={1000}>
				<Switch>
					<Route exact path="/">
						{buildings && buildings.length > 1 ? (
							<Welcome buildings={buildings} />
						) : (
							<Redirect to={`/batiment/${buildings[0].name}`} />
						)}
					</Route>
					<Route exact path="/batiment/:id" component={Layout} />
					<Route exact path="/lot/:poi" component={Poi} />
					<Route exact path="/district" component={DistrictMode} />
					<Route exact path="/district/:poi" component={DistrictPoi} />
					<PublicRoute exact path="/login" component={Login} />
					<PublicRoute exact path="/admin/login" component={Login} />
					<PrivateRoute exact path="/admin" component={Dashboard} />
					<PrivateRoute exact path="/admin/dashboard" component={Dashboard} />
					<PrivateRoute exact path="/admin/tables" component={Tables} />
					<Route component={NotFound} />
				</Switch>
			</CSSTransition>
		</TransitionGroup>
	);
}

export default Routes;
